'use client';

import React, { useCallback, memo } from 'react';

import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import ModalBackBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalBackBtn';
import ModalHomeBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalHomeBtn';

import * as S from './style';

interface IProps {
  /** bgType */
  bgType?: 'white' | 'transparent' | undefined;
  /** title */
  title?: string;
  /** onClickHome */
  onClickHome?: () => void;
  /** onClickBack */
  onClickBack?: () => void;
  /** onClickClose */
  onClickClose?: () => void;
}

const PopupHeader = ({
  title,
  bgType = 'white',
  onClickHome,
  onClickBack,
  onClickClose,
}: IProps) => {
  // EVENT HANDLER : 홈 클릭
  const handleHome = useCallback(() => {
    if (onClickHome) {
      onClickHome();
    }
  }, [onClickHome]);

  // EVENT HANDLER : handleClose
  const handleClose = useCallback(() => {
    if (onClickClose) {
      onClickClose();
    }
  }, [onClickClose]);

  return (
    <S.PopupHeader className="popup-header" $bgType={bgType}>
      <div className="inner-header">
        {onClickBack && (
          <div className="area-left">
            <ModalBackBtn onClick={onClickBack} />
          </div>
        )}
        {title && (
          <Title>
            <span>{title}</span>
          </Title>
        )}
        {(onClickHome || onClickClose) && (
          <div className="area-right">
            {onClickHome && <ModalHomeBtn onClick={handleHome} />}
            {onClickClose && <ModalCloseBtn onClick={handleClose} />}
          </div>
        )}
      </div>
    </S.PopupHeader>
  );
};

export default memo(PopupHeader);
